import React from 'react';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Icon from "@mui/material/Icon";
import Alert from "@mui/material/Alert";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

function EditLeaseForm (props) {
    const  {
        rentAmount,
        rentDeposit,
        leaseAddress,
        tenantValue,
        options,
        loading,
        loadingButton,
        errorMessage,
        errors,
        onChangeRentAmount,
        onChangeRentDeposit,
        onChangeLeaseAddress,
        setTenantValue,
        onChangeArea,
        area,
        setOptions,
        remarks,
        onChangeRemarks,
        onHandleSubmit,
    } = props;
    // console.log("tenantValue", tenantValue);

    return (
        <MDBox pt={0} pb={3}>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <Card>
                    <Grid container spacing={2} sx={{ padding: "19px 20px"}}>
                        <Grid item xs={12} md={12}>
                        <MDBox component="form" role="form" method="POST" onSubmit={onHandleSubmit}>
                            <MDBox mb={2}>
                            <MDInput
                                type="number"
                                label="Rent Amount"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                sx={{
                                "& .MuiInput-underline:after": { borderBottomColor: "#388e3c"},
                                "& .MuiInputLabel-root.Mui-focused": { color: "#388e3c" }
                                }}
                                value={rentAmount}
                                onChange={onChangeRentAmount}
                                name='rent_amount'
                            />
                            {( errorMessage && errors ) && (
                                <FormHelperText error>{errorMessage}</FormHelperText>
                            )}
                            </MDBox>
                            <MDBox mb={2}>
                            <MDInput
                                type="number"
                                label="Rent Deposit"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                sx={{
                                "& .MuiInput-underline:after": { borderBottomColor: "#388e3c"},
                                "& .MuiInputLabel-root.Mui-focused": { color: "#388e3c" }
                                }}
                                value={rentDeposit}
                                onChange={onChangeRentDeposit}
                                name='rent_deposit'
                            />
                            </MDBox>
                            <MDBox mb={2}>
                            <MDInput
                                type="number"
                                label="Area"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                sx={{
                                "& .MuiInput-underline:after": { borderBottomColor: "#388e3c"},
                                "& .MuiInputLabel-root.Mui-focused": { color: "#388e3c" }
                                }}
                                value={area}
                                onChange={onChangeArea}
                                name='area'
                            />
                            </MDBox>
                            <MDBox mb={2}>
                            <MDInput
                                type="text"
                                label="Lease Address"
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                sx={{
                                "& .MuiInput-underline:after": { borderBottomColor: "#388e3c"},
                                "& .MuiInputLabel-root.Mui-focused": { color: "#388e3c" }
                                }}
                                value={leaseAddress}
                                onChange={onChangeLeaseAddress}
                                name='lease_address'
                            />
                            {( errorMessage && errors ) && (
                                <FormHelperText error>{errorMessage}</FormHelperText>
                            )}
                            </MDBox>
                            <MDBox mt={4} mb={1} textAlign="right">
                            <Autocomplete
                                disableCloseOnSelect
                                options={options || []}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) => {return value?.id && option.id === value.id;}}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Tenants"
                                    InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                        </>
                                    ),
                                    }}
                                />
                                )}
                                renderOption={(props, option, state) => (
                                <li {...props} key={option.id}>
                                    {option.label}
                                </li>
                                )}
                                value={tenantValue}
                                onChange={(event, value) => {
                                console.log(typeof value, value);
                                setTenantValue(value);
                                }}
                                loading={loading}
                                noOptionsText={
                                <MDButton
                                    variant="gradient"
                                    sx={{
                                    padding: "12px 30px",
                                    backgroundColor: "#388e3c",
                                    color: "#ffffff",
                                    borderRadius: "0.2rem",
                                    "&:hover": {
                                        backgroundColor: "#919191",
                                        color: "#fff",
                                    },
                                    "&:disabled": {
                                        background: "#e0e0e0"
                                    }
                                    }}
                                    onClick={() => {
                                    const newTenant = prompt("Enter new tenant name:");
                                    if (newTenant) {
                                        const newTenantOption = { id: 0, label: newTenant };
                                        setOptions((prevOptions) => [...prevOptions, newTenantOption]);
                                        setTenantValue(newTenantOption);
                                    }
                                    }}
                                >
                                    Add New Tenant
                                </MDButton>
                                }
                            />
                            </MDBox>
                            {tenantValue && tenantValue.id === 0 && (
                            <MDBox mt={2} mb={2}>
                                <Alert severity="info">
                                Please click save changes to generate new Tenant, otherwise the previous action won't be saved.
                                </Alert>
                            </MDBox>
                            )}
                            { tenantValue && tenantValue.id != 0 && (
                            <MDBox mt={1} mb={1} textAlign="left">
                                <MDButton
                                href={`https://mgt.yeelim.org/#/tenants/${tenantValue.id}/edit`}
                                // href={`https://mgt.yyproperty.org/#/tenants/${tenantValue.id}/edit`}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="gradient"
                                sx={{
                                    padding: "12px 25px",
                                    backgroundColor: "#388e3c",
                                    color: "#ffffff",
                                    borderRadius: "0.2rem",
                                    "&:hover": {
                                    backgroundColor: "#919191",
                                    color: "#fff",
                                    },
                                    "&:disabled": {
                                    background: "#e0e0e0"
                                    },
                                    "&:focus:not(:hover)": {
                                    backgroundColor: "#388e3c"
                                    }
                                }}
                                startIcon={<Icon>visibility</Icon>}
                                type="submit"
                                >
                                View / Edit Tenant
                                </MDButton>
                            </MDBox>
                            )}
                            <MDBox mt={3}>
                                <MDInput
                                    label="Remarks"
                                    fullWidth
                                    multiline
                                    rows={5} 
                                    value={remarks}
                                    onChange={onChangeRemarks}
                                />
                            </MDBox>
                            <MDBox mt={4} mb={1} textAlign="right">
                            <MDButton
                                variant="gradient"
                                sx={{
                                padding: "12px 30px",
                                backgroundColor: "#388e3c",
                                color: "#ffffff",
                                borderRadius: "0.2rem",
                                "&:hover": {
                                    backgroundColor: "#919191",
                                    color: "#fff",
                                },
                                "&:disabled": {
                                    background: "#e0e0e0"
                                }
                                }}
                                startIcon={loadingButton && <CircularProgress color="inherit" size={20} />}
                                disabled={errors || loadingButton}
                                type="submit"
                            >
                                Save Lease
                            </MDButton>
                            </MDBox>
                        </MDBox>
                        </Grid>
                    </Grid>
                    </Card>
                </Grid>
            </Grid>
        </MDBox>
    )
}

export default EditLeaseForm;
